<div class="footer" [class.border-top]="borderTop" [class.position-absolute]="positionAbsolute">
  <app-reminder-message
    *ngIf="alertMessage"
    [message]="alertMessage"
    [type]="type"
    [hiddenIcon]="hiddenIcon"
  ></app-reminder-message>

  <p class="hint" *ngIf="hint" [innerHTML]="hint"></p>
  <div class="action max-width" *ngIf="showButton">
    <button
      [appButton]="buttonColor"
      *ngIf="!hiddenPrimaryBtn"
      (click)="!disabled && confirm.emit()"
      class="max-width"
      [disabled]="disabled"
    >
      {{ label }}
    </button>
    <button
      appButton="secondary"
      (click)="actionSecondaryBtn.emit()"
      class="max-width margin"
      *ngIf="labelSecondary"
    >
      {{ labelSecondary }}
    </button>
  </div>

  <div class="logo-section">
    <p class="privacy" *ngIf="privacyPolicy" (click)="utils.openPrivacy()">
      {{ 'POLICY' | translate }}
    </p>
    <div class="powered-by">
      <p>powered by</p>
      <img src="assets/icons/platform-logo.svg" alt="logo" />
    </div>
  </div>
</div>
